import styled from 'styled-components'

export const Button = styled.button`
    height: 2rem;
    left: 85px;
    top: 408px;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #95A6B5;
    text-transform: capitalize;

    &:hover {
        box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.3);
    }
    `
